import React from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import Footer from '../components/Footer';
import { Header } from '../components/Header';

// Unknown URLs: a real "not found" page (noindex) instead of redirecting to /login,
// which search engines treat as a soft 404.
export default function NotFound() {
  return (
    <div className="w-full min-h-screen" style={{ background: 'var(--surface-0)', color: 'var(--text-1)' }}>
      <Helmet>
        <title>Page not found | My Football Game</title>
        <meta name="robots" content="noindex, follow" />
      </Helmet>
      <div className="container mx-auto px-4">
        <Header />
      </div>
      <div className="max-w-xl mx-auto px-4 py-20 text-center">
        <div className="pc-eyebrow pc-eyebrow-accent mb-3">404</div>
        <h1 className="text-3xl font-bold mb-3">This page is offside</h1>
        <p className="text-[var(--text-3)] mb-8">The page you were looking for doesn't exist or has moved.</p>
        <div className="flex flex-wrap justify-center gap-3">
          <Link to="/" className="px-5 py-2.5 rounded-lg font-bold text-sm" style={{ background: 'var(--accent)', color: 'var(--surface-0)' }}>Go to the homepage</Link>
          <Link to="/blog" className="px-5 py-2.5 rounded-lg font-bold text-sm" style={{ background: 'var(--surface-2)' }}>Read the guides</Link>
        </div>
      </div>
      <Footer />
    </div>
  );
}
